import { FunctionOpenInNewTab } from "radium-omnibus";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_ADD_OUR_LINE,
  TEXT_AN_ORDER_SERVICE_HOME,
  TEXT_CONNECT_WITH_US,
  TEXT_CONTACTUS_ALSO,
  TEXT_CONTACT_US_SERVICE_HOME,
  TEXT_CONTACT_US_SERVICE_HOME_2,
  TEXT_CONTACT_US_SERVICE_HOME_3,
  TEXT_CONTACT_US_SERVICE_HOME_4,
  TEXT_CREATE,
  TEXT_FAQ,
  TEXT_FAQ_SERVICE_BKK_PTY,
  TEXT_GET_IN_TOUCH,
  TEXT_HOW_TO_CREATE_AN_ORDER,
  TEXT_HOW_TO_CREATE_AN_ORDER_DETAIL,
  TEXT_HOW_TO_CREATE_AN_ORDER_DETAIL_2,
  TEXT_OR,
  TEXT_OR_FOR_SOME_CONTACTUS,
  TEXT_SERVICE_HOME,
  TEXT_SERVICE_HOME_BOLD,
} from "../../../utils/useConstants";

import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_2_REGULAR_TEXT_BASE,
  STYLE_HEADING_2,
  STYLE_ICON_CONTACT_US,
  STYLE_ICON_CONTACT_US_DISABLE,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
  STYLE_SPACE_LIST_CONTACTUS,
  STYLE_TEXT_CONTACT,
  STYLE_TEXT_CONTACT_MEDIUM,
  STYLE_UNDERLUBE_BLUE_CONTACTUS,
} from "../../../utils/useStyle";

const ConnectwithDesktop = () => {
  const { language } = React.useContext(ContextLanguage);

  return (
    <div className={`${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center`}>
      {/* {TEXT_CONNECT_WITH_US[language]} */}
      {language === "TH" ? (
        <div>
          นอกจาก Line Official Account และช่วงเวลาให้บริการที่กล่าวข้างต้นแล้ว
          คุณสามารถติดต่อเราได้ผ่านทางแอปแชทต่างๆ <br /> ด้วยเบอร์โทร (+66)
          092-516-5458
        </div>
      ) : (
        <div>
          <div>
            Apart from our Line Official Account and during the abovementioned
            service hours, we are also online and ready to serve you on various
            messenger apps. Just add us by our
          </div>
          <div> Thai phone number (+66) 092-516-5458</div>
        </div>
      )}

      {/* <a href="tel:+66925165458">
        <span className={`${`STYLE_LINK_BLUE`}`}> 092-516-5458 </span>
      </a> */}
      {TEXT_OR_FOR_SOME_CONTACTUS[language]}
    </div>
  );
};

const ConnectwithMobile = () => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className={`${STYLE_TEXT_CONTACT(language)}`}>
      {TEXT_CONNECT_WITH_US[language]}
      <div>{language === "TH" && "ด้วยเบอร์โทร"}</div>
      <div className="  ">
        Thai phone number (+66)
        <a href="tel:+66925165458">
          <span className={`${STYLE_LINK_BLUE}`}>092-516-5458</span>
        </a>
      </div>
      <div>
        {TEXT_OR[language]} ID
        <span className={STYLE_LINK_BLUE}>mylaundrythai</span>
      </div>
    </div>
  );
};

const HeadList = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div className=" md:space-y-6">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_SERVICE_HOME[language]}
      </div>
      <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>
      <div
        className={`${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center`}
      >
        <span className=" font-semibold">
          {TEXT_SERVICE_HOME_BOLD[language]}
        </span>
        {isMobile ? (
          <span>
            {TEXT_CONTACT_US_SERVICE_HOME_2[language]}{" "}
            <div>{TEXT_CONTACT_US_SERVICE_HOME_3[language]}</div>{" "}
            {TEXT_CONTACT_US_SERVICE_HOME_4[language]}
          </span>
        ) : (
          TEXT_CONTACT_US_SERVICE_HOME[language]
        )}

        <span
          onClick={() => {
            navigate("/OurServices");
          }}
          className={STYLE_LINK_BLUE}
        >
          {TEXT_CREATE[language]}
        </span>
        {TEXT_AN_ORDER_SERVICE_HOME[language]}
        <span>
          {/* {TEXT_CONTACTUS_ALSO[language]} */}
          <span
            onClick={() => {
              navigate("/FAQ");
            }}
            className={STYLE_LINK_BLUE}
          >
            {TEXT_FAQ[language]}
          </span>
          {TEXT_FAQ_SERVICE_BKK_PTY[language]}
        </span>
      </div>
    </div>
  );
};

const GetInTouch = () => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className=" md:space-y-6">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_GET_IN_TOUCH[language]}
      </div>
      <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>
      <div
        className={`${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center`}
      >
        {TEXT_ADD_OUR_LINE[language]}
      </div>
      <div className=" flex gap-1 justify-center items-center mt-4 ">
        <img
          src="/icons/icon_line.png"
          className={STYLE_ICON_CONTACT_US}
          onClick={() => {
            FunctionOpenInNewTab(
              "https://page.line.me/?accountId=mylaundrythai"
            );
          }}
        />

        <div
          onClick={() => {
            FunctionOpenInNewTab(
              "https://page.line.me/?accountId=mylaundrythai"
            );
          }}
          className={STYLE_TEXT_CONTACT_MEDIUM(language) + " cursor-pointer"}
        >
          @mylaundrythai
        </div>
      </div>
    </div>
  );
};

const Howtocreate = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  return (
    <div className=" md:space-y-6">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {/* {TEXT_HOW_TO_CREATE_AN_ORDER[language]} */}
        {language === "TH"
          ? "ที่ตั้ง (ไม่รับวอร์ค-อิน)"
          : "Locations (No Walk-In)"}
      </div>
      <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>
      <div
        className={`${STYLE_BODY_2_REGULAR_TEXT_BASE(language)} text-center`}
      >
        {/* {TEXT_HOW_TO_CREATE_AN_ORDER_DETAIL[language]}
        <span
          onClick={() => {
            navigate("/OurServices");
          }}
          className={STYLE_LINK_BLUE}
        >
          {TEXT_CREATE[language]}
        </span>
        {TEXT_HOW_TO_CREATE_AN_ORDER_DETAIL_2[language]} */}

        {language === "TH" ? (
          <div>
            <div>
              บ้านเลขที่ 128/71 ซอยแม้นศรี แขวงคลองมหานาค เขตป้อมปราบศัตรูพ่าย
              กรุงเทพฯ 10100
            </div>
            <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>

            <div>
              บ้านเลขที่ 13/1 ซอย 45 ถนนประชาสงเคราะห์ แขวงดินแดง เขตดินแดง
              กรุงเทพฯ 10400
            </div>
          </div>
        ) : (
          <div>
            <div>
              No. 128/71 Soi Maensri, Khlong Maha Nak, Pom Prab Sattru Phai,
              Bangkok, 10100
            </div>
            <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>

            <div>
              No. 13/1, Soi 45 Pracha Songkhro Road, Din Daeng, Din Daeng,
              Bangkok, 10400
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const ConnectWithUs = () => {
  const isMobile = useIsMobile();

  const [load, setLoad] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setLoad(true);
    }, 1000);
  }, []);

  if (load) {
    return (
      <div className=" space-y-4 md:space-y-6">
        {/* {isMobile ? <ConnectwithMobile /> : <ConnectwithDesktop />} */}
        <ConnectwithDesktop />

        <div className="flex justify-center items-center gap-2">
          <img
            src="/icons/iconblue_whatsapp.png"
            className={STYLE_ICON_CONTACT_US}
            onClick={() => {
              FunctionOpenInNewTab("http://wa.me/66925165458");
            }}
          />
          <img
            src="/icons/iconblue_facebook.png"
            className={STYLE_ICON_CONTACT_US}
            onClick={() => {
              FunctionOpenInNewTab("http://m.me/mylaundrythai");
            }}
          />
          <img
            src="/icons/iconblue_telegram.png"
            className={STYLE_ICON_CONTACT_US}
            onClick={() => {
              FunctionOpenInNewTab("https://t.me/mylaundrythai");
              // alert("Coming soon");
            }}
          />
          <img
            src="/icons/iconblue_wechat.png"
            className={`w-9 `}
            onClick={() => {
              // FunctionOpenInNewTab("http://wa.me/66925165458");
              // alert("Coming soon");
            }}
          />

          <img
            src="/icons/iconblue_viber.png"
            className={STYLE_ICON_CONTACT_US_DISABLE}
            onClick={() => {
              // FunctionOpenInNewTab("http://wa.me/66925165458");
              // alert("Coming soon");
            }}
          />
          <img
            src="/icons/iconblue_signal.png"
            className={STYLE_ICON_CONTACT_US_DISABLE}
            onClick={() => {
              // FunctionOpenInNewTab("http://wa.me/66925165458");
              // alert("Coming soon");
            }}
          />
          <img
            src="/icons/iconblue_kakao.png"
            className={STYLE_ICON_CONTACT_US_DISABLE}
            onClick={() => {
              // FunctionOpenInNewTab("http://wa.me/66925165458");
              // alert("Coming soon");
            }}
          />
        </div>
      </div>
    );
  }
};

const ContactList = () => {
  return (
    <div
      className={`${STYLE_SPACE_LIST_CONTACTUS} ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_READING}`}
    >
      <HeadList />
      <GetInTouch />
      <ConnectWithUs />
      {/* <img src="/images/logo.png" className=" h-10 md:h-12 mx-auto " /> */}
      <Howtocreate />
    </div>
  );
};
export default ContactList;
